import Box from '@/components/ui/Box/Box';
import type { VehicleColorDotProps } from './IVehicleColorDot';

const CSS_COLOR: Record<string, string> = {
    Beige: '#F5F5DC',
    Black: '#1A1A1A',
    Blue: '#1E63D7',
    Brown: '#8B5A2B',
    Gold: '#D4AF37',
    Gray: '#9CA3AF',
    Green: '#1B9E4B',
    Orange: '#F1810B',
    Purple: '#7C3AED',
    Red: '#E53935',
    Silver: '#C0C0C0',
    White: '#FFFFFF',
    Yellow: '#F1C40F',
};

const VehicleColorDot = ({ color, size = 16 }: VehicleColorDotProps) => {
    const css = CSS_COLOR[color] ?? color.toLowerCase();
    return (
        <Box
            component="span"
            sx={{
                display: 'inline-block',
                width: size,
                height: size,
                borderRadius: '50%',
                backgroundColor: css,
                border: '1px solid',
                borderColor: 'grey.200',
                boxSizing: 'border-box',
                flexShrink: 0,
                verticalAlign: 'middle',
                lineHeight: 0,
            }}
        />
    );
};

export default VehicleColorDot;
